<template>
    <div class="bidding-price-data">
        <SectionRowJustified>
            <template #title>
                <slot name="total:title">{{ $t('BiddingPriceData.totalValue') }}</slot>
            </template>
            <template #value>
                <slot name="total:value">
                    <Price
                        v-if="listPrice"
                        :minimum-price="listPrice"
                        class="bidding-price-data__total-value"
                        :show-prefix="false"
                        ignore-price-mode
                    />
                </slot>
            </template>
        </SectionRowJustified>

        <slot name="middle"></slot>

        <SectionRowJustified class="bidding-price-data__bid">
            <template #title>
                <slot name="bid:title"> {{ $t('BiddingPriceData.currentBid') }}</slot>
            </template>
            <template #value>
                <slot name="bid:value">
                    <Price
                        v-if="bidAmount"
                        :minimum-price="bidAmount"
                        class="bidding-price-data__total-value bidding-price-data__bid-value"
                        :show-prefix="false"
                        ignore-price-mode
                    />
                </slot>
            </template>
        </SectionRowJustified>
    </div>
</template>

<script>
import SectionRowJustified from '@/components/SectionRowJustified.vue';
import Price from '@/components/Price.vue';

export default {
    name: 'BiddingPriceData',
    components: { Price, SectionRowJustified },

    props: {
        listPrice: {
            type: Number
        },
        bidAmount: {
            type: Number
        }
    }
};
</script>

<style scoped lang="scss">
.bidding-price-data {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    & > * {
        margin-bottom: 0; // we already have gap set
    }

    &__bid-value {
        font-weight: 700;
    }
}
</style>
